import type { PortalResource } from '@/lib/navGrant'

/**
 * What each resource a token or a connected app can be granted covers, in plain words, for a person deciding what
 * an outside app may do (the consent screen). The resource ids are the API's names for the first segment of a route
 * (`packages/db/src/api-token.ts`); nobody granting access away should have to know them.
 *
 * Each phrase is lower case because it sits in the middle of a sentence ("What Agent One may do with your own
 * mailbox"); a list that shows one on its own capitalises the first letter. Keyed by the resource type, so a
 * resource added to `API_TOKEN_RESOURCES` without words here fails the type check.
 */
export const RESOURCE_DESCRIPTIONS: Record<PortalResource, string> = {
    billing: "the company's plan, payments and invoices",
    blockers: 'work that is blocked or has failed',
    catalog: 'teams and tasks shared by other companies',
    chats: 'chats with team members',
    enterprise: "the company's settings and access keys",
    executions: 'workflows and how far each one has got',
    gates: 'approvals waiting on a person',
    kpis: 'the goals and numbers the company tracks',
    llm: 'AI accounts and models',
    mail: 'your own mailbox',
    members: 'AI team members and their jobs',
    memory: 'what the company has learned',
    orgs: 'how the company is organised',
    plans: 'plans for upcoming work',
    proposals: 'proposed changes to how work is done',
    recommendations: 'suggestions for improving the team',
    roles: 'roles and what each one covers',
    runs: 'work in progress and its results',
    spend: 'AI spending and its limits',
    tasks: 'tasks and how they are set up',
    teams: 'teams and the work they own',
    tools: 'tools and the accounts they connect to',
    users: 'the people who can sign in, and invitations',
    webhooks: 'messages sent to other systems when something happens',
}
